import { inherits as _inherits, createSuper as _createSuper, classCallCheck as _classCallCheck, defineProperty as _defineProperty, assertThisInitialized as _assertThisInitialized, createClass as _createClass, taggedTemplateLiteral as _taggedTemplateLiteral, toArray as _toArray, toConsumableArray as _toConsumableArray, extends as _extends, objectWithoutProperties as _objectWithoutProperties } from '../../_virtual/_rollupPluginBabelHelpers.js';
import propTypes from '../../node_modules/prop-types/index.js';
import { styled, useThemeProps, TableRow as TableRow$1, TableCell, TableBody, CircularProgress, Table as Table$2, TableHead, TableFooter } from '@mui/material';
import classnames from '../../node_modules/classnames/index.js';
import React from 'react';
import { ExpandTableRowsType } from './constants.js';
import TableRow from './rows/TableRow.js';
import HeaderRow from './rows/HeaderRow.js';
import FooterRow from './rows/FooterRow.js';
import ExpandedRow from './rows/ExpandedRow.js';
import ErrorMessage from '../api/ErrorMessage.js';
import VirtualizedList$1 from '../../cinnamon-web/es/components/utility/VirtualizedList.js';
import { createComponentSlot } from '../../modules/styling/theme.js';
import TableColumn from './columns/TableColumn.js';
import SelectableColumn from './columns/SelectableColumn.js';
import MenuCell from './cells/MenuCell.js';
import MenuCellItem from './cells/MenuCellItem.js';

var _templateObject;

var _excluded = ["data", "dataKey", "loading", "slowLoading", "error", "emptyMessage", "noHeader", "showFooter", "selectable", "onRowClick", "expandRows", "renderExpandedRow", "maxExpandedRows", "initialExpandedRows", "columns", "children", "className", "sx", "variant", "renderRowContent", "renderRowLink", "virtualized", "virtualizationOptions", "getRowClassName"];
var componentRoot = createComponentSlot({
  name: "CinTable",
  slot: "Root"
});
var DEFAULT_DATA_KEY = "key";

var TableBase = /*#__PURE__*/function (_React$Component) {
  _inherits(TableBase, _React$Component);

  var _super = _createSuper(TableBase);

  function TableBase(props) {
    var _this;

    _classCallCheck(this, TableBase);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "_keyWarning", false);

    _defineProperty(_assertThisInitialized(_this), "_columnsWarning", false);

    _defineProperty(_assertThisInitialized(_this), "componentDidUpdate", function (prevProps) {
      if (prevProps.data !== _this.props.data || prevProps.dataKey !== _this.props.dataKey) {
        _this._keyWarning = false;
      }
    });

    _defineProperty(_assertThisInitialized(_this), "getItemKey", function (item) {
      var _this$props$dataKey = _this.props.dataKey,
          dataKey = _this$props$dataKey === void 0 ? DEFAULT_DATA_KEY : _this$props$dataKey;
      var key = item[dataKey];

      if (!key && !_this._keyWarning) {
        console.warn("Table dataKey is invalid");
        _this._keyWarning = true;
      }

      return key;
    });

    _defineProperty(_assertThisInitialized(_this), "getTotalColumns", function () {
      var required = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var columns = _this.props.columns;

      if (!columns && !_this._columnsWarning && required) {
        console.warn("Table columns has not been defined");
        _this._columnsWarning = true;
      }

      return columns;
    });

    _defineProperty(_assertThisInitialized(_this), "getColumnSpan", function () {
      var children = _this.props.children;
      return typeof children === "function" ? _this.getTotalColumns() : _this.getTotalColumns(false) || React.Children.count(children);
    });

    _defineProperty(_assertThisInitialized(_this), "isRowExpanded", function (itemKey) {
      var expandRows = _this.props.expandRows;
      return expandRows !== ExpandTableRowsType.Never && (expandRows === ExpandTableRowsType.Always || _this.state.expandedRows.some(function (x) {
        return x === itemKey;
      }));
    });

    _defineProperty(_assertThisInitialized(_this), "onRowClick", function (item, itemKey) {
      var _this$props = _this.props,
          onRowClick = _this$props.onRowClick,
          expandRows = _this$props.expandRows;

      if (expandRows === ExpandTableRowsType.OnClick) {
        var rowExpanded = _this.isRowExpanded(itemKey);

        if (rowExpanded) {
          _this.onRowCollapse(itemKey);
        } else {
          _this.onRowExpand(itemKey);
        }
      }

      if (onRowClick) onRowClick(item);
    });

    _defineProperty(_assertThisInitialized(_this), "onRowExpand", function (itemKey) {
      var maxExpandedRows = _this.props.maxExpandedRows;

      var expandedRows = _this.state.expandedRows.filter(function (x) {
        return x !== itemKey;
      });

      if (maxExpandedRows && expandedRows.length >= maxExpandedRows) {
        var _expandedRows = _toArray(expandedRows);
            _expandedRows[0];
            var remainingRows = _expandedRows.slice(1);

        _this.setState({
          expandedRows: [].concat(_toConsumableArray(remainingRows), [itemKey])
        });
      } else {
        _this.setState({
          expandedRows: [].concat(_toConsumableArray(expandedRows), [itemKey])
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onRowCollapse", function (itemKey) {
      var expandedRows = _this.state.expandedRows;

      _this.setState({
        expandedRows: expandedRows.filter(function (x) {
          return x !== itemKey;
        })
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderVirtualizedRows", function (start, end) {
      var _data$slice;

      var data = _this.props.data;
      var rows = (_data$slice = data === null || data === void 0 ? void 0 : data.slice(start, end)) !== null && _data$slice !== void 0 ? _data$slice : [];
      return _this.renderBodyRows(rows, start);
    });

    var _props$initialExpande = props.initialExpandedRows,
        initialExpandedRows = _props$initialExpande === void 0 ? [] : _props$initialExpande;
    _this.state = {
      expandedRows: initialExpandedRows
    };
    return _this;
  }

  _createClass(TableBase, [{
    key: "renderHeaderRow",
    value: function renderHeaderRow() {
      var _this$props2 = this.props,
          data = _this$props2.data,
          dataKey = _this$props2.dataKey,
          children = _this$props2.children;
      return /*#__PURE__*/React.createElement(HeaderRow, {
        data: data,
        dataKey: dataKey
      }, children);
    }
  }, {
    key: "renderFooterRow",
    value: function renderFooterRow() {
      var _this$props3 = this.props,
          data = _this$props3.data,
          dataKey = _this$props3.dataKey,
          children = _this$props3.children;
      return /*#__PURE__*/React.createElement(FooterRow, {
        data: data,
        dataKey: dataKey
      }, children);
    }
  }, {
    key: "renderErrorRow",
    value: function renderErrorRow(columnSpan) {
      var error = this.props.error;
      if (!error) return null;
      var errorStyle = {
        padding: 0
      };
      return /*#__PURE__*/React.createElement(TableRow$1, null, /*#__PURE__*/React.createElement(TableCell, {
        colSpan: columnSpan,
        style: errorStyle
      }, /*#__PURE__*/React.createElement(ErrorMessage, {
        error: error
      })));
    }
  }, {
    key: "renderBodyRows",
    value: function renderBodyRows(rows) {
      var _this2 = this;

      var indexOffset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var _this$props4 = this.props,
          _this$props4$data = _this$props4.data,
          data = _this$props4$data === void 0 ? [] : _this$props4$data,
          _this$props4$dataKey = _this$props4.dataKey,
          dataKey = _this$props4$dataKey === void 0 ? DEFAULT_DATA_KEY : _this$props4$dataKey,
          _this$props4$selectab = _this$props4.selectable,
          selectable = _this$props4$selectab === void 0 ? false : _this$props4$selectab,
          onRowClick = _this$props4.onRowClick,
          expandRows = _this$props4.expandRows,
          renderExpandedRow = _this$props4.renderExpandedRow,
          noHeader = _this$props4.noHeader,
          showFooter = _this$props4.showFooter,
          children = _this$props4.children,
          renderRowContent = _this$props4.renderRowContent,
          renderRowLink = _this$props4.renderRowLink,
          getRowClassName = _this$props4.getRowClassName;
      var columnSpan = this.getColumnSpan();
      return rows.map(function (item, i) {
        var index = indexOffset + i;
        var itemKey = _this2.getItemKey(item) || index;

        var expanded = _this2.isRowExpanded(itemKey);

        return /*#__PURE__*/React.createElement(React.Fragment, {
          key: itemKey
        }, /*#__PURE__*/React.createElement(TableRow, {
          data: data,
          dataKey: dataKey,
          item: item,
          itemKey: itemKey,
          itemIndex: index,
          onClick: !!onRowClick || expandRows === ExpandTableRowsType.OnClick ? _this2.onRowClick : undefined,
          onExpand: _this2.onRowExpand,
          onCollapse: _this2.onRowCollapse,
          expanded: expanded,
          selectable: selectable,
          headerExists: !noHeader,
          footerExists: !!showFooter,
          renderRowLink: renderRowLink,
          getRowClassName: getRowClassName
        }, renderRowContent ? renderRowContent(index) : children), renderExpandedRow && /*#__PURE__*/React.createElement(ExpandedRow, {
          item: item,
          itemKey: itemKey,
          itemIndex: index,
          render: renderExpandedRow,
          columnSpan: columnSpan,
          onCollapse: _this2.onRowCollapse,
          visible: expanded
        }));
      });
    }
  }, {
    key: "renderBody",
    value: function renderBody() {
      var _this$props5 = this.props,
          data = _this$props5.data,
          loading = _this$props5.loading,
          slowLoading = _this$props5.slowLoading,
          emptyMessage = _this$props5.emptyMessage,
          virtualized = _this$props5.virtualized,
          virtualizationOptions = _this$props5.virtualizationOptions;
      var columnSpan = this.getColumnSpan();
      var showLoading = loading && (slowLoading || slowLoading === undefined || !data || data.length === 0);

      if (showLoading) {
        return /*#__PURE__*/React.createElement(TableBody, null, /*#__PURE__*/React.createElement(TableRow$1, null, /*#__PURE__*/React.createElement(TableCell, {
          colSpan: columnSpan,
          align: "center"
        }, /*#__PURE__*/React.createElement(CircularProgress, null))));
      }

      if (!data) {
        return /*#__PURE__*/React.createElement(TableBody, null, this.renderErrorRow(columnSpan));
      }

      if (data.length === 0) {
        return /*#__PURE__*/React.createElement(TableBody, null, /*#__PURE__*/React.createElement(TableRow$1, null, /*#__PURE__*/React.createElement(TableCell, {
          colSpan: columnSpan,
          align: "center"
        }, emptyMessage)), this.renderErrorRow(columnSpan));
      }

      if (virtualized) {
        return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(VirtualizedList$1, _extends({}, virtualizationOptions, {
          totalItems: data.length,
          renderItems: this.renderVirtualizedRows,
          batchComponent: TableBody
        })), /*#__PURE__*/React.createElement(TableBody, null, this.renderErrorRow(columnSpan)));
      }

      return /*#__PURE__*/React.createElement(TableBody, null, this.renderBodyRows(data), this.renderErrorRow(columnSpan));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props6 = this.props;
          _this$props6.data;
          _this$props6.dataKey;
          _this$props6.loading;
          _this$props6.slowLoading;
          _this$props6.error;
          _this$props6.emptyMessage;
          var noHeader = _this$props6.noHeader,
          showFooter = _this$props6.showFooter;
          _this$props6.selectable;
          _this$props6.onRowClick;
          _this$props6.expandRows;
          _this$props6.renderExpandedRow;
          _this$props6.maxExpandedRows;
          _this$props6.initialExpandedRows;
          _this$props6.columns;
          _this$props6.children;
          var className = _this$props6.className;
          _this$props6.sx;
          _this$props6.variant;
          _this$props6.renderRowContent;
          _this$props6.renderRowLink;
          _this$props6.virtualized;
          _this$props6.virtualizationOptions;
          _this$props6.getRowClassName;
          var otherProps = _objectWithoutProperties(_this$props6, _excluded);

      return /*#__PURE__*/React.createElement(Table$2, _extends({}, otherProps, {
        className: classnames(componentRoot.className, className)
      }), !noHeader && /*#__PURE__*/React.createElement(TableHead, null, this.renderHeaderRow()), this.renderBody(), showFooter && /*#__PURE__*/React.createElement(TableFooter, null, this.renderFooterRow()));
    }
  }]);

  return TableBase;
}(React.Component);

_defineProperty(TableBase, "propTypes", {
  data: propTypes.arrayOf(propTypes.any),
  dataKey: propTypes.string,
  loading: propTypes.bool,
  slowLoading: propTypes.bool,
  error: propTypes.any,
  emptyMessage: propTypes.node,
  noHeader: propTypes.bool,
  showFooter: propTypes.bool,
  selectable: propTypes.bool,
  onRowClick: propTypes.func,
  renderRowLink: propTypes.func,
  expandRows: propTypes.any,
  renderExpandedRow: propTypes.func,
  initialExpandedRows: propTypes.arrayOf(propTypes.any),
  maxExpandedRows: propTypes.number,
  columns: propTypes.number,
  children: propTypes.oneOfType([propTypes.node, propTypes.func]),
  renderRowContent: propTypes.func,
  virtualized: propTypes.bool,
  virtualizationOptions: propTypes.any,
  className: propTypes.string,
  sx: propTypes.any,
  variant: propTypes.any,
  getRowClassName: propTypes.func
});

_defineProperty(TableBase, "defaultProps", {
  dataKey: DEFAULT_DATA_KEY,
  emptyMessage: "No Results",
  expandRows: ExpandTableRowsType.None,
  initialExpandedRows: [],
  noHeader: false,
  showFooter: false,
  selectable: false
});

var TableRoot = styled(TableBase, componentRoot.styledOptions)(_templateObject || (_templateObject = _taggedTemplateLiteral([""])));
/**
 * A table that renders an array of data
 */

var Table = function Table(props) {
  var rootProps = useThemeProps({
    props: props,
    name: componentRoot.name
  });
  return /*#__PURE__*/React.createElement(TableRoot, rootProps);
}; // bundle related sub-components

/** Renders a standard column for a table data item */


Table.Column = TableColumn;
/** Renders a column with checkboxes for selecting items */

Table.SelectableColumn = SelectableColumn;
/** Renders a row for a table data item */

Table.Row = TableRow;
/** Renders a row for a table header */

Table.HeaderRow = HeaderRow;
/** Renders a row for a table footer */

Table.FooterRow = FooterRow;
/** Renders an expanded row for a table data item */

Table.ExpandedRow = ExpandedRow;
/** Renders a cell which contains a dropdown menu */

Table.Menu = MenuCell;
/** A single item for a table menu cell */

Table.MenuItem = MenuCellItem;
var Table$1 = Table;

export { Table$1 as default };
